import React, { ReactElement, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';

import { DogParkRoutes } from 'dogpark/utilities/const';
import { NavigationMenuStyled } from './NavigationMenu.styles';

function NavigationMenu(): ReactElement {
  const [selectedMenuKey, setSelectedMenuKey] = useState('');
  const { pathname } = useLocation();

  useEffect(() => {
    const { Breeders, BreederAdminUsers } = DogParkRoutes;
    pathname.includes(Breeders) && setSelectedMenuKey(Breeders);
    pathname.includes(BreederAdminUsers) && setSelectedMenuKey(BreederAdminUsers);
  }, [pathname]);

  return (
    <NavigationMenuStyled mode="horizontal" selectedKeys={[selectedMenuKey]}>
      <Menu.Item key={DogParkRoutes.Breeders}>
        <Link to={DogParkRoutes.Breeders}>Breeders</Link>
      </Menu.Item>
      <Menu.Item key={DogParkRoutes.BreederAdminUsers}>
        <Link to={DogParkRoutes.BreederAdminUsers}>Admins</Link>
      </Menu.Item>
    </NavigationMenuStyled>
  );
}

export default NavigationMenu;
